export default __webpack_public_path__ + "static/BergenMono-Regular-2b01d356bc29ac1858cc399ca19be039.woff2";